interface ActiveBranchHeaderProps {
  endDate?: string;
  /** 정지 상태면 회색 바 + 정지 기한 표기 */
  banned?: boolean;
  banTo?: string | null;
}

export default function ActiveBranchHeader({ endDate, banned = false, banTo }: ActiveBranchHeaderProps) {
  if (banned) {
    return (
      <div className="w-full bg-gray-05 py-2 text-center">
        <p className="text-style-body-03 w-full font-bold text-black">
          [지점 정지됨] 지점 정지 기한 : ~ {banTo || "-"}
        </p>
      </div>
    );
  }
  return (
    <div className="w-full py-2 text-center bg-primary-50">
      <p className="w-full text-[14px] font-bold text-white">[지점 활성중] 지점 서비스 사용기한 : ~ {endDate}</p>
    </div>
  );
}
